/**
 * Dialog panels
 */

var dialogOverlay = document.querySelector('.dialog-overlay');
var limousineDialogEl = document.querySelector('.js-limousine-dialog');
var zpracovaniStareniMasaDialogEl = document.querySelector('.js-zpracovani-stareni-masa-dialog');
var expediceMasaDialogEl = document.querySelector('.js-expedice-masa-dialog');
var objednavkaDialogEl = document.querySelector('.js-objednavka-dialog');

var limousineDialog = new Dialog(limousineDialogEl, dialogOverlay);
limousineDialog.addEventListeners('.js-open-limousine-dialog', '.js-close-limousine-dialog');

var zpracovaniStareniMasaDialog = new Dialog(zpracovaniStareniMasaDialogEl, dialogOverlay);
zpracovaniStareniMasaDialog.addEventListeners('.js-open-zpracovani-stareni-masa-dialog', '.js-close-zpracovani-stareni-masa-dialog');

var expediceMasaDialog = new Dialog(expediceMasaDialogEl, dialogOverlay);
expediceMasaDialog.addEventListeners('.js-open-expedice-masa-dialog', '.js-close-expedice-masa-dialog');

var objednavkaDialog = new Dialog(objednavkaDialogEl, dialogOverlay);
objednavkaDialog.addEventListeners('.js-open-objednavka-dialog', '.js-close-objednavka-dialog');



/**
 * Webp support
 */

function checkWebPFeature(feature, callback) {
    var kTestImages = {
        lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
        animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
    };
    var img = new Image();
    img.onload = function () {
        var result = (img.width > 0) && (img.height > 0);
        callback(feature, result);
    };
    img.onerror = function () {
        callback(feature, false);
    };
    img.src = "data:image/webp;base64," + kTestImages[feature];
}

checkWebPFeature('lossy', function() {
	document.body.classList.add('webp');
});



/**
 * Cookie banner
 */

window.addEventListener('load', function() {
	window.dataLayer = window.dataLayer || [];
	function gtag() { dataLayer.push(arguments); }

	// obtain plugin
	var cc = initCookieConsent();

	// run plugin with your configuration
	cc.run({
		current_lang: 'cs',
		autoclear_cookies: true,                   // default: false

		// page_scripts: true,                     // default: false
		// mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
		// delay: 0,                               // default: 0
		// auto_language: '',                      // default: null; could also be 'browser' or 'document'
		// autorun: true,                          // default: true
		// force_consent: false,                   // default: false
		// hide_from_bots: false,                  // default: false
		// remove_cookie_tables: false             // default: false
		// cookie_name: 'cc_cookie',               // default: 'cc_cookie'
		// cookie_expiration: 182,                 // default: 182 (days)
		// cookie_necessary_only_expiration: 182   // default: disabled
		// cookie_domain: location.hostname,       // default: current domain
		// cookie_path: '/',                       // default: root
		// cookie_same_site: 'Lax',                // default: 'Lax'
		// use_rfc_cookie: false,                  // default: false
		// revision: 0,                            // default: 0

		onFirstAction: function(user_preferences, cookie){
			var consents = {
				'ad_storage': 'denied',
				'analytics_storage': 'denied',
				'functionality_storage': 'denied',
				'personalization_storage': 'denied',
				'security_storage': 'denied'
			};

			if (cookie['level'] && cookie['level'].includes('ad_storage')) {
				consents['ad_storage'] = 'granted';
			}

			if (cookie['level'] && cookie['level'].includes('analytics_storage')) {
				consents['analytics_storage'] = 'granted';
			}

			gtag('consent', 'update', consents);
			dataLayer.push({'event': 'consent-update'});
		},

		onChange: function (cookie, changed_categories) {
			var consents = {
				'ad_storage': 'denied',
				'analytics_storage': 'denied',
				'functionality_storage': 'denied',
				'personalization_storage': 'denied',
				'security_storage': 'denied'
			};

			if (cookie['level'] && cookie['level'].includes('ad_storage')) {
				consents['ad_storage'] = 'granted';
			}

			if (cookie['level'] && cookie['level'].includes('analytics_storage')) {
				consents['analytics_storage'] = 'granted';
			}

			gtag('consent', 'update', consents);
			dataLayer.push({'event': 'consent-update'});
		},

		gui_options: {
			consent_modal: {
				layout: 'cloud',               // box/cloud/bar
				position: 'bottom center',     // bottom/middle/top + left/right/center
				transition: 'slide',           // zoom/slide
				swap_buttons: false            // enable to invert buttons
			},
			settings_modal: {
				layout: 'box',                 // box/bar
				// position: 'left',           // left/right
				transition: 'slide'            // zoom/slide
			}
		},

		languages: {
			'cs': {
				consent_modal: {
					title: 'Používáme soubory cookies 🍪',
					description: 'Naše webové stránky používají soubory cookies a další nástroje s cílem vylepšení uživatelského prostředí a zobrazení reklam, analýzy návštěvnosti webových stránek a zjištění zdroje návštěvnosti. <button type="button" data-cc="c-settings" class="cc-link">Upravit mé předvolby</button>',
					primary_btn: {
						text: 'Souhlasím',
						role: 'accept_all'              // 'accept_selected' or 'accept_all'
					},
					secondary_btn: {
						text: 'Odmítám',
						role: 'accept_necessary'        // 'settings' or 'accept_necessary'
					}
				},
				settings_modal: {
					title: 'Předvolby souborů cookies',
					save_settings_btn: 'Uložit nastavení',
					accept_all_btn: 'Přijmout vše',
					reject_all_btn: 'Odmítnout vše',
					close_btn_label: 'Zavřít',
					cookie_table_headers: [
						{col1: 'Name'},
						{col2: 'Domain'},
						{col3: 'Expiration'},
						{col4: 'Description'}
					],
					blocks: [
						{
							title: 'Vaše soukromí je pro nás důležité 📢',
							description: 'Soubory cookies jsou velmi malé textové soubory, které se ukládají do vašeho zařízení při navštěvování webových stránek. Soubory cookies používáme pro různé účely s cílem vylepšení uživatelského prostředí a zobrazení reklam, analýzy návštěvnosti webových stránek a zjištění zdroje návštěvnosti.<br /><br /> Při procházení našich webových stránek můžete změnit své předvolby a odmítnout určité typy cookies, které se mají ukládat do vašeho počítače. Můžete také odstranit všechny soubory cookie, které jsou již uloženy ve vašem počítači, ale mějte na paměti, že odstranění souborů cookie vám může zabránit v používání částí našeho webu.'
						}, {
							title: 'Bezpodmínečně nutné soubory cookies',
							description: 'Tyto soubory cookies jsou nezbytné k tomu, abychom vám mohli poskytovat služby dostupné prostřednictvím našeho webu a abychom vám umožnili používat určité funkce našeho webu.',
							toggle: {
								value: 'necessary_storage',
								enabled: true,
								readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
							}
						}, {
							title: 'Sledovací a výkonnostní soubory cookies',
							description: 'Tyto soubory cookies se používají ke shromažďování informací pro analýzu provozu na našich webových stránkách a sledování používání našich webových stránek uživateli.<br /><br /> Tyto soubory cookies mohou například sledovat věci jako je doba kterou na webu trávíte, nebo stránky, které navštěvujete, což nám pomáhá pochopit, jak pro vás můžeme vylepšit náš web.<br /><br /> Informace shromážděné prostřednictvím těchto sledovacích a výkonnostních cookies neidentifikují žádné osoby.',
							toggle: {
								value: 'analytics_storage',     // your cookie category
								enabled: false,
								readonly: false
							},
							cookie_table: [             // list of all expected cookies
								{
									col1: '^_ga',       // match all cookies starting with "_ga"
									col2: 'google.com',
									col3: '2 roky',
									col4: 'Sledování návštěvnosti stránky a analýza pohybu na webu.',
									is_regex: true
								},
								{
									col1: '_gid',
									col2: 'google.com',
									col3: '1 den',
									col4: 'Sledování návštěvnosti stránky a analýza pohybu na webu.',
								}
							]
						}, {
							title: 'Cookies pro cílení a reklamu',
							description: 'Tyto soubory cookie se používají k zobrazování reklamy, která vás pravděpodobně bude zajímat na základě vašich zvyků při procházení.<br /><br /> Tyto soubory cookie, jsou požadovány námi/nebo poskytovateli reklam, mohou kombinovat informace shromážděné z našich webových stránek s dalšími informacemi, které nezávisle shromáždily z jiných webových stránek, týkající se činností vašeho internetového prohlížeče v rámci jejich reklamní sítě webových stránek.<br /><br /> Pokud se rozhodnete tyto soubory cookies pro cílení nebo reklamu odstranit nebo deaktivovat, budou se vám reklamy stále zobrazovat, ale nemusí pro vás být nadále personalizované a relevantní.',
							toggle: {
								value: 'ad_storage',
								enabled: false,
								readonly: false
							}
						}, {
							title: 'Další informace',
							description: 'V případě jakýchkoliv dotazů ohledně našich zásad týkajících se souborů cookie a vašich možností nás prosím kontaktujte.'
						}
					]
				}
			}
		}
	});
});
